import { http, HttpResponse } from 'msw';

const baseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/invitation_links`;

type InvitationLinksRecordType = Required<{
  started_at: string;
  finished_at: string;
  suspended: boolean;
  description: string | null;
  family_name_required: boolean;
  given_name_required: boolean;
  identifying_code_required: boolean;
  password_required: boolean;
  auto_approval: boolean;
  admins: {
    email: string;
    family_name: string | null;
    given_name: string | null;
  }[];
  departments: {
    id: number;
    name: string;
    subs: {
      id: number;
      name: string;
      subs: {
        id: number;
        name: string;
      }[];
    }[];
  }[];
}>;

const invitationLinksRecord: InvitationLinksRecordType = {
  started_at: '2022-01-01T00:00:00+09:00',
  finished_at: '2027-01-01T00:00:00+09:00',
  suspended: false,
  description:
    'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
  family_name_required: true,
  given_name_required: true,
  identifying_code_required: true,
  password_required: true,
  auto_approval: true,
  admins: [
    {
      email: 'sample1@mail.com',
      family_name: 'シグネイト',
      given_name: '一郎',
    },
    {
      email: 'sample2@mail.com',
      family_name: 'シグネイト',
      given_name: '二郎',
    },
  ],
  departments: [
    {
      id: 1,
      name: 'HRx事業本部',
      subs: [
        {
          id: 11,
          name: 'HRx営業部',
          subs: [
            { id: 111, name: 'セールスプロモーション' },
            { id: 112, name: 'アカウントエグゼクティブ' },
            { id: 113, name: 'カスタマーサポート' },
          ],
        },
        {
          id: 12,
          name: '総務部',
          subs: [
            { id: 121, name: '庶務課' },
            { id: 122, name: '経理課' },
          ],
        },
      ],
    },
    {
      id: 2,
      name: '技術本部',
      subs: [
        {
          id: 21,
          name: '開発部',
          subs: [
            { id: 211, name: 'Web開発' },
            { id: 212, name: 'アプリ開発' },
            { id: 213, name: 'インフラ開発' },
            { id: 214, name: 'データ開発' },
            { id: 215, name: 'エラー' },
          ],
        },
        {
          id: 22,
          name: '品質保証部',
          subs: [
            { id: 221, name: '品質管理' },
            { id: 222, name: 'テスト管理' },
          ],
        },
        {
          id: 23,
          name: '運用部',
          subs: [
            { id: 231, name: '運用管理' },
            { id: 232, name: '運用保守' },
          ],
        },
        {
          id: 24,
          name: 'エラー',
          subs: [],
        },
      ],
    },
    {
      id: 3,
      name: 'エラー',
      subs: [],
    },
  ],
};

export const invitationLinksHandlers = [
  // 招待リンク情報取得
  http.post(baseUrl, async ({ request }) => {
    const postRequest = (await request.json()) as {
      token: string;
    };
    console.info(postRequest);

    if (postRequest.token !== 'invalid_token') {
      return HttpResponse.json(invitationLinksRecord);
    } else {
      return HttpResponse.json(
        { error_type: 'error', message: '無効なリンクです' },
        { status: 404 }
      );
    }
  }),
  // 招待リンク受領
  http.post(`${baseUrl}/follow`, async ({ request }) => {
    const postRequest = (await request.json()) as {
      token: string;
      email: string;
      email_confirmation: string;
      family_name: string | null;
      given_name: string | null;
      department_one_id: number | null;
      department_two_id: number | null;
      department_three_id: number | null;
      identifying_code: string | null;
      password: string | null;
    };
    console.info(postRequest);

    if (postRequest.email === 'error@dummy.com') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'email',
              message: '正しいメールアドレスを入力してください。',
            },
          ],
        },
        { status: 400 }
      );
    } else if (postRequest.email === 'followed@dummy.com') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'email',
              message: '既に申請済みのメールアドレスです',
            },
          ],
        },
        { status: 400 }
      );
    } else if (postRequest.email === 'registered@dummy.com') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'email',
              message: '有効な契約が存在するため、割り当てる必要がありません',
            },
          ],
        },
        { status: 400 }
      );
    } else if (postRequest.password === 'wrongPassword') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'password',
              message: '認証パスワードが一致しません',
            },
          ],
        },
        { status: 400 }
      );
    } else if (postRequest.department_one_id === 3) {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'department_one_id',
              message: '部署1IDが不正です',
            },
          ],
        },
        { status: 400 }
      );
    } else if (postRequest.department_two_id === 24) {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'department_two_id',
              message: '部署2IDが不正です',
            },
          ],
        },
        { status: 400 }
      );
    } else if (postRequest.department_three_id === 215) {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'department_three_id',
              message: '部署3IDが不正です',
            },
          ],
        },
        { status: 400 }
      );
    } else {
      const response = invitationLinksRecord.admins;
      console.info(response);

      return HttpResponse.json(response);
    }
  }),
];
